export default __webpack_public_path__ + "static/media/CT.8db706b5.png";